import firebase from 'firebase'
import 'firebase/firestore'

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyC5_vXF4iDSUtz_f475Dj_j1ls8wblQ2I0',
  authDomain: 'lily-314608.firebaseapp.com',
  projectId: 'lily-314608',
  storageBucket: 'lily-314608.appspot.com',
  messagingSenderId: '88354463232',
  appId: '1:88354463232:web:88fa67afef0a3e234a82e5',
  measurementId: 'G-L1077MKHDN',
}
// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
export default db